export default function nav() {
	
	$('#header .hamburger').on('click', function (e) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.nav-container' ).toggleClass( 'active' );
		$( '#header .logo' ).toggleClass( 'mobile' );
  });

}